// extracted by mini-css-extract-plugin
export default {"contact":"Facilities_contact__XQdMH","none":"Facilities_none__7n--q"};